import { atom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';

export type FloatingOpenButtonPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'middleLeft'
  | 'middleRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

export const developerMenuOpenAtom = atom(false);

export const jotaiDevToolsOpenAtom = atom(false);
export const reactQueryDevtoolsOpenAtom = atom(false);

export const openButtonPositionAtom =
  atomWithStorage<FloatingOpenButtonPosition>(
    'developer-menu-open-button-position',
    'middleRight',
    undefined,
    {
      getOnInit: true,
    },
  );

export const developerMenuOpenButtonHiddenAtom = atomWithStorage(
  'developer-menu-open-button-hidden',
  false,
  undefined,
  {
    getOnInit: true,
  },
);

export const developerMenuSearchQueryAtom = atom('');

export const debugSearchSessionAtom = atom(false);
debugSearchSessionAtom.debugLabel = 'debugSearchSession';

/* ------- Subcommand Modal State ------- */

/**
 * Open/closed state for each item's subcommand modal, keyed by the item's
 * `id`. The engine reads it to render the modal and writes it to toggle — no
 * item-specific atom or key needs to be declared.
 */
export const subcommandOpenAtomFamily = atomFamily((_id: string) =>
  atom(false),
);

/* -------------------------------------- */
